<div class="overflow-x-auto pb-2">
  <div [style.width.%]="100" [style.min-width.px]="minWidth">
    <apx-chart
      [series]="series"
      [chart]="chart"
      [colors]="colors"
      [plotOptions]="plotOptions"
      [dataLabels]="dataLabels"
      [stroke]="stroke"
      [xaxis]="xaxis"
      [yaxis]="yaxis"
      [legend]="legend"
      [grid]="grid"
      [fill]="fill"
      [tooltip]="tooltip"
    >
    </apx-chart>
  </div>
</div>
